import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { FeasibilitySpec, FeasibilityResult, FeasibilityGeoNames } from '../models/feasibility';

@Injectable({
  providedIn: 'root'
})
export class FeasibilityService {

  private baseUrl = environment.apiEndpoint + '/feasibility';
  private geoNames$: Observable<FeasibilityGeoNames> | null = null;

  constructor(private http: HttpClient) {}

  GetFeasibility(specs: FeasibilitySpec[]): Observable<FeasibilityResult[]> {
    return this.http.post<FeasibilityResult[]>(this.baseUrl, specs);
  }

  /** DMA + county lookup names; static per deployment, so fetched once and replayed. */
  GetGeoNames(): Observable<FeasibilityGeoNames> {
    if (!this.geoNames$) {
      this.geoNames$ = this.http.get<FeasibilityGeoNames>(this.baseUrl + '/geo-names').pipe(shareReplay(1));
    }
    return this.geoNames$;
  }
}
